import { GlobalLightHub } from "./typing";
import { GLOBAL_KEY, LIGHTHUB_WRAN_PREFIX } from "./const";
import { logger, timer } from "./logger";

//find first parent with tagName [tagname]
export function findParent (tagname: string, el: Element | null) {
    while (el){
        if ((el.nodeName || el.tagName).toLowerCase()===tagname.toLowerCase()){
            return el;
        }
        // @ts-ignore
        el = el.parentNode;
    }
    return null;
}

export function getGlobalLightHub() {
    // @ts-ignore
    return window[GLOBAL_KEY] as GlobalLightHub;
}

export function getAsyncQueueId() {
    return getGlobalLightHub().asyncQueueId;
}

export function isLightWran(e: Error) {
    return e.message && e.message.indexOf(LIGHTHUB_WRAN_PREFIX) !== -1;
}

export function newLightHubWran(msg: string) {
    return new Error(LIGHTHUB_WRAN_PREFIX + ':' + msg);
}

export function isNative (Ctor: Object): boolean {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

export async function runInQueue<T>(task: () => Promise<T>): Promise<T> {
    const asyncQueueId = getAsyncQueueId();

    try {
        const promise = task();

        let startTime = 0;
        if (process.env.NODE_ENV !== 'production') {
            startTime = Date.now();
        }
        // 
        const result = await promise;

        // 

        if (asyncQueueId !== getAsyncQueueId()) {
            throw newLightHubWran('async queue changed');
        }

        return result;
    } catch(e) {
        

        if (isLightWran(e)) {
        } else {
            console.error('LightHub catch a error:', e.stack);
        }


        if (asyncQueueId !== getAsyncQueueId()) {
            throw newLightHubWran('async queue changed');
        }

        return Promise.reject(e);
    }
}


export function timeout(ms: number) {
    return new Promise(r => {
        const lighthub = getGlobalLightHub();
        const _setTimeout = (lighthub && lighthub.origins._setTimeout.bind(window)) || window.setTimeout;
        setTimeout(r, ms);
    })
}

export function isIgnoreScript(src: string) {
    if (!src) {
        return false;
    }
    const ignores = getGlobalLightHub().globalIgnoreScript;
    return ignores.indexOf(src) !== -1;
}

export function runInOriginTimeout(cb: Function) {
    const _setTimeout = window.setTimeout;
    window.setTimeout = getGlobalLightHub().origins._setTimeout;
    cb();
    window.setTimeout = _setTimeout;
}

export function runSafe(cb: Function) {
    try {
        cb();
    } catch(e) {
        console.log('error', e);
    }
}

export function domReady(cb: Function) {
    if (/complete|interactive|loaded/.test(document.readyState)) {
        // In case the document has finished parsing, document's readyState will
        // be one of "complete", "interactive" or (non-standard) "loaded".
        cb();
    } else {
        // The document is not ready yet, so wait for the DOMContentLoaded event
        document.addEventListener('DOMContentLoaded', () => cb(), false);
    }
}
